import styles from './primaryObjectiveSection.module.scss';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { StudyInfoPageSection } from '../../layoutComponents/StudyInfoPageLayout';
import { useGetDoctorStudyByIdQuery } from 'src/services/api/api-client/StudyQuery';

export const PrimaryObjectiveSection = () => {
  const { id } = useStudy() ?? {};
  const { data, isInitialLoading } = useGetDoctorStudyByIdQuery(id!, {
    keepPreviousData: false,
    refetchOnMount: 'always',
  });
  const { t } = useScopedTranslation('StudyInfoPage.PrimaryObjectiveSection');

  return (
    <StudyInfoPageSection
      title={t('Title')}
      placeholderProps={{
        text: t('Placeholder'),
        showPlaceholder: !data?.primaryObjectiveText,
        className: styles.placeholder,
      }}
      isLoading={isInitialLoading}
      isFullHeight={!!data?.primaryObjectiveText}
    >
      <div className={styles.container}>{data?.primaryObjectiveText ?? '-'}</div>
    </StudyInfoPageSection>
  );
};
